import i18next from 'i18next'
import z from 'zod'

import { transferListSchema } from 'components/Form/TransferList'
import { schema as globalSetupDefaultsMultiAnchorSchema } from 'features/globalSetup/pages/Defaults/RichPlacements/Sections/MultiAnchorSection/schema'
import { matchTypeValues } from 'features/inventory/page/types/matchType'
import { Domain } from 'features/inventory/types/domain'

export const MAX_ACTIVE_AD_UNITS: number = 8

export const schema = z
  .object({
    adUnitIds: transferListSchema.safeExtend({
      right: z.array(z.string()).max(MAX_ACTIVE_AD_UNITS),
    }),
    customizeAppearance: z.boolean().default(false),
    customizeBasicSettings: z.boolean().default(false),
    customVariableName: z.string().optional(),
    customVariableTriggerEnabled: z.boolean().default(false),
    customVariableValue: z.string().optional(),
    enabled: z.boolean().default(false),
    matchType: z.enum(matchTypeValues).optional(),
    path: z.string().optional(),
    pathTriggerEnabled: z.boolean().default(false),
  })
  .safeExtend(globalSetupDefaultsMultiAnchorSchema.shape)
  .superRefine((data: Schema, ctx: z.RefinementCtx): void => {
    const { customVariableName, customVariableTriggerEnabled, customVariableValue } = data

    if (customVariableTriggerEnabled === true) {
      if (customVariableName === undefined || customVariableName.length === 0) {
        ctx.addIssue({
          code: 'custom',
          message: i18next.t(
            'features/domain:form.richPlacements.multiAnchor.triggers.customVariableName.requiredError',
          ),
          path: ['customVariableName'],
        })
      }

      if (customVariableValue === undefined || customVariableValue.length === 0) {
        ctx.addIssue({
          code: 'custom',
          message: i18next.t(
            'features/domain:form.richPlacements.multiAnchor.triggers.customVariableValue.requiredError',
          ),
          path: ['customVariableValue'],
        })
      }
    }
  })

export type Schema = z.infer<typeof schema>

export const schemaDefault = (domain: Domain): Schema => {
  const {
    domainRichPlacementMultiAnchor: {
      adUnitIds,
      customizeAppearance,
      customizeBasicSettings,
      customStyling,
      customVariableName,
      customVariableTriggerEnabled,
      customVariableValue,
      displayAfterUserInteraction,
      enabled,
      fullWidthMode,
      matchType,
      path,
      pathTriggerEnabled,
      showCloseButton,
      singleAdViewTime,
    },
  } = domain

  return {
    adUnitIds: { left: [], right: adUnitIds },
    customizeAppearance,
    customizeBasicSettings,
    customStyling,
    customVariableName,
    customVariableTriggerEnabled,
    customVariableValue,
    displayAfterUserInteraction,
    enabled,
    fullWidthMode,
    matchType,
    path,
    pathTriggerEnabled,
    showCloseButton,
    singleAdViewTime,
  }
}
